var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNintoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96942 10.1364C6.06897 8.08472 8.29101 6.79224 10.7188 6.79224C13.392 6.79224 15.1236 9.46703 13.9129 11.7262L9.10661 20.6945C8.0833 22.6039 6.01533 23.8068 3.75588 23.8068C0.957032 23.8068 -0.855932 21.0063 0.411682 18.641L4.96942 10.1364Z",
    fill: "#00a000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2532 3.11232C22.2765 1.20286 24.3445 0 26.6039 0C29.4028 0 31.2157 2.8005 29.9481 5.16581L25.2661 13.9022C24.2428 15.8117 22.1748 17.0145 19.9154 17.0145C17.1166 17.0145 15.3036 14.214 16.5712 11.8487L21.2532 3.11232Z",
    fill: "#00a000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7134 20.9101C12.4329 19.594 13.8662 18.7677 15.43 18.7677H19.2383C20.8073 18.7677 21.8184 20.3438 21.0966 21.6643C20.3772 22.9804 18.9438 23.8067 17.38 23.8067H13.5717C12.0027 23.8067 10.9916 22.2307 11.7134 20.9101Z",
    fill: "#00a000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNintoLogo);
export default __webpack_public_path__ + "static/media/nintoLogo.59913341ec9765f3af0e8a65752cfff0.svg";
export { ForwardRef as ReactComponent };